<template>
  <div class="parent">
    <title-widge :title="title" :subTitle="subTitle"></title-widge>
    <div class="divContent">
      <div class="divItem" v-for="(item, index) in items" :key="index">
        <div class="divImg">
          <img v-lazy="{
            src:item.url,
            loading: require('./../../../../../assets/wheelplanting.jpg'),
          }" />
        </div>
        <div class="divTitle">{{ item.title }}</div>
        <div class="divDesc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/industryAdvantageWidge.scss";
</style>
